module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-stone-path-background.b8041030.png";